import * as ProgressPrimitive from '@radix-ui/react-progress';
import clsx from 'clsx';
import * as React from 'react';

function Progress({
  className,
  rootClassName,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {
  value: number;
  rootClassName?: string;
}) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={clsx(
        'bg-fx-neutral-200 relative h-2 w-full overflow-hidden rounded-full',
        rootClassName,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={clsx(
          'bg-fx-neutral-600 h-full w-full flex-1 transition-all',
          className,
        )}
        style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
